import { MiDataTableVisibility, MiDataTableOptions } from '@/components/MiDataTable/MiDataTable';
import { Contractor } from '@/models/Contractor';
import { Report } from '@/models/Report';
import { getStatusColor, getStatusLabel } from '@/support/ReportStatus';
import { Component, Model, Prop, Vue } from 'vue-property-decorator';

@Component<Planning>({ })
export default class Planning extends Vue {
  protected $pageTitle = 'Planning';

  @Model('contractor', { default: () => new Contractor() })
  protected contractor!: Contractor;

  @Prop({ default: false })
  protected syncing!: boolean;

  protected isLoading = false;

  protected getPillColor(status: string): string {
    return getStatusColor(status);
  }

  protected getPillLabel(status: string): string {
    return getStatusLabel(status);
  }

  protected get tableOptions(): MiDataTableOptions {
    return {
      model: new Report().include('contractor').filter({ contractor: this.contractor ? this.contractor.uuid : '' }),
      headers: [
        {
          text: 'Zaaknummer',
          value: 'case_number',
        },
        {
          text: 'IMG Zaaknummer',
          value: 'img_case_number',
          sortable: true,
        },
        {
          text: 'Startdatum',
          value: 'planned_at',
          sortable: true,
        },
        {
          text: 'Oplevermoment',
          value: 'deadline_at',
          sortable: true,
        },
        {
          text: 'Adres',
          value: 'address',
          sortable: false,
        },
        {
          text: 'Schades',
          value: 'damage_count',
          sortable: true,
        },
        {
          text: 'Status',
          value: 'status_raw',
          sortable: false,
          align: 'end',
        },
      ],
    };
  }

  protected get visibility(): MiDataTableVisibility {
    return {
      filters: false,
    };
  }
}
